/* RESPONSIBLE TEAM: team-actions */
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default class IdentityMapping extends EmbercomBaseSerializer {
  attrs = {
    status: { serialize: false },
  };
}
